import React from "react";

const checkEffortHandler = (values, options) => {
  let objConvert = Object.keys(options);
  for (let i = 0; objConvert.length > i; i++) {
    let key = objConvert[i];
    let value = options[key];

    if (values > value.total_hours) {
      //return value.name;
      return values + " H" || 0;
    }
  }
};

const formatTime = (days, hours) => {
  var days = days > 0 && days < 10 ? "0" + days : days;
  if (hours > 0) {
    var hours = "0" + hours;
    if (days > 0) {
      return `  ${days || 0} D \u00A0 ${hours || 0} H `;
    } else {
      return `  ${hours || 0} H `;
    }
  } else {
    if (days > 0) return `  ${days || 0} D `;
  }
};

const EffortCellRenderer = ({ value }) => {

  if (!value?.total_hours) return <div></div>;

  return formatTime(value.effort_in_days, value.effort_in_hours);
};

export default EffortCellRenderer;
